var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center"},[(_vm.dataLoaded)?_c('highcharts',{ref:"wrapper",staticClass:"stock",attrs:{"constructor-type":'stockChart',"options":_vm.stockOptions}}):_c('div',[_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.status))])],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10a6e38c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/openorders/StockChart.vue
// module id = 8Tk6
// module chunks = 0